import { Box, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GroupAccordian from "./GroupAccordian";
import { Add } from "@mui/icons-material";
import Atomic from "../../../AComponent/Atomic";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const { Button } = Atomic;
const DownloadExcelButton = ({
  secondGroups,
  firstGroups,
  parameters,
  dimName,
  MapName,
}) => {
  const [loading, setLoading] = useState(false);
  const handleDownload = () => {
    if (!parameters?.list?.length) return;
    setLoading(true);
    console.log("PARAMTER: ", parameters, " ", firstGroups, " ", secondGroups);

    const secGroupMapping = {};
    const firstGroupMapping = {};
    if (secondGroups?.list?.length) {
      secondGroups.list.forEach((item) => {
        secGroupMapping[item.SecondGroupID] = item;
      });
    }
    if (firstGroups?.list?.length) {
      firstGroups.list.forEach((item) => {
        firstGroupMapping[item.FirstGroupID] = item;
      });
    }
    const data = [];
    parameters.list.forEach((item) => {
      console.log("ITEM IS: ", item);

      const row = {};
      const firstGroupId = item.ParameterGroupID;
      const firstGroup = firstGroupMapping[firstGroupId];
      let secondGroup;
      if (firstGroup?.SecondGroupID) {
        const secondGroupId = firstGroup.SecondGroupID;
        secondGroup = secGroupMapping[secondGroupId];
      }
      if (MapName) row["Parameter Map"] = MapName;
      else row["Parameter Map"] = "";
      if (dimName) row["Dimension Name"] = dimName;
      else row["Dimension Name"] = "";
      if (secondGroup?.GroupName) row["Group 2 Label"] = secondGroup.GroupName;
      else row["Group 2 Label"] = "";
      if (firstGroup?.FirstGroupName)
        row["Group 1 Label"] = firstGroup.FirstGroupName;
      else row["Group 1 Label"] = "";

      if (item?.ParameterName) row["Parameter"] = item.ParameterName;
      else row["Parameter"] = "";
      row["Min Weight"] = item.MinimumWeight;
      row["Max Weight"] = item.MaximumWeight;
      row["Weight"] = item.Weight;
      data.push(row);
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write workbook to binary array
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create Blob and trigger download
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(dataBlob, "data.xlsx");
    setLoading(false);
  };

  return (
    <Button
      // style={{ marginTop: "2em" }}
      startIcon={<FileDownloadIcon />}
      onClick={handleDownload}
      title={"Download Data"}
      variant={"outlined"}
      isLoading={loading}
    />
  );
};
const ListView = ({
  secondGroups,
  firstGroups,
  parameters,
  cycles,
  dimName,
  MapName,
  fromSettings,
}) => {
  const [collapse, setCollapse] = useState(false);

  useEffect(() => {}, [parameters]);

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          // margin: "1em 0",
        }}
      >
        <Button
          onClick={() => {
            setCollapse(!collapse);
          }}
          title={collapse ? "Expand All" : "Collapse All"}
          variant={"text"}
        />

        {fromSettings && (
          <DownloadExcelButton
            secondGroups={secondGroups}
            firstGroups={firstGroups}
            parameters={parameters}
            dimName={dimName}
            MapName={MapName}
          />
        )}
      </Box>
      {(!secondGroups.list || secondGroups.list.length === 0) &&
      (!firstGroups.list || firstGroups.list.length === 0) &&
      (!parameters.list || parameters.list.length === 0) ? (
        <div className="Flex">
          <Typography variant="h6" fontWeight={"400"} color={"#AAA7AC"}>
            No parametes to display
          </Typography>
        </div>
      ) : (
        <Box style={{ paddingRight: "1em" }}>
          {!secondGroups.disabled && (
            <Box>
              {(secondGroups.list || []).map((group2) => {
                return (
                  <GroupAccordian
                    key={group2.TransactionID || group2.SecondGroupID}
                    TransactionID={group2.TransactionID || group2.SecondGroupID}
                    collapse={collapse}
                    type={"g2"}
                    expandable={true}
                    title={group2.GroupName || group2.SecondGroupName}
                    //  caption={"1 KRA * 2 KPIs"}
                    {...secondGroups.props}
                  >
                    {!firstGroups.disabled &&
                      (firstGroups.list || []).map((group1) => {
                        console.log(parameters, "Inside");
                        return group1.SecondGroupID === group2.TransactionID ? (
                          <GroupAccordian
                            key={group1.TransactionID || group1.FirstGroupID}
                            TransactionID={
                              group1.TransactionID || group1.FirstGroupID
                            }
                            title={group1.GroupName || group1.FirstGroupName}
                            // caption={"1 KRA * 2 KPIs"}
                            collapse={collapse}
                            type={"g1"}
                            expandable={true}
                            {...firstGroups.props}
                          >
                            {(parameters.list || []).map((parameter) => {
                              console.log(
                                parameters.props.missingParameters,
                                "missingParameterAssessments",
                                parameter.ParameterID,
                                parameter
                              );
                              return parameter.ParameterGroupID ===
                                group1.TransactionID ? (
                                <GroupAccordian
                                  key={
                                    parameter.TransactionID ||
                                    parameter.ParameterID
                                  }
                                  collapse={collapse}
                                  type={"p"}
                                  expandable={parameters.expandable}
                                  title={parameter.ParameterName}
                                  ParameterDescription={
                                    parameter.ParameterDescription
                                  }
                                  parameterWeight={
                                    (parameter.Targets || [])[0]?.Weight
                                  }
                                  parameterItemNumber={parameter.ItemNumber}
                                  dataError={parameters.props.missingParameters?.includes(
                                    parameter.ParameterID
                                  )}
                                  TransactionID={
                                    parameter.TransactionID ||
                                    parameter.ParameterID
                                  }
                                  // caption={"1 KRA * 2 KPIs"}
                                  {...parameters.props}
                                >
                                  {parameters.expandable && (
                                    <parameters.children.Component
                                      parameter={parameter}
                                      collapse={collapse}
                                      {...parameters.children.props}
                                    />
                                  )}
                                </GroupAccordian>
                              ) : (
                                <></>
                              );
                            })}
                            {parameters.props.permissions.addable && (
                              <Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  margin: "1em 0",
                                }}
                              >
                                <IconButton
                                  onClick={() => {
                                    parameters.props.addModalHandler(
                                      group2,
                                      group1
                                    );
                                  }}
                                  sx={{
                                    backgroundColor: "#3a82d3",
                                    ":hover": { backgroundColor: "#4091ed" },
                                  }}
                                >
                                  <Add sx={{ color: "white" }} />
                                </IconButton>
                              </Box>
                            )}
                          </GroupAccordian>
                        ) : (
                          <></>
                        );
                      })}
                    {firstGroups.props.permissions.addable && (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-start",
                          margin: "1em 0",
                        }}
                      >
                        <IconButton
                          onClick={() => {
                            firstGroups.props.addModalHandler(
                              group2.TransactionID
                            );
                          }}
                          sx={{
                            backgroundColor: "#3a82d3",
                            ":hover": { backgroundColor: "#4091ed" },
                          }}
                        >
                          <Add sx={{ color: "white" }} />
                        </IconButton>
                      </Box>
                    )}
                  </GroupAccordian>
                );
              })}
            </Box>
          )}
          {secondGroups.disabled && !firstGroups.disabled && (
            <Box>
              {(firstGroups.list || []).map((group1) => {
                return !group1.SecondGroupID ? (
                  <GroupAccordian
                    key={group1.TransactionID || group1.FirstGroupID}
                    collapse={collapse}
                    TransactionID={group1.TransactionID || group1.FirstGroupID}
                    title={group1.GroupName || group1.FirstGroupName}
                    //  caption={"1 KRA * 2 KPIs"}
                    type={"g1"}
                    expandable={true}
                    {...firstGroups.props}
                  >
                    {(parameters.list || []).map((parameter) => {
                      return parameter.ParameterGroupID ===
                        group1.TransactionID ? (
                        <GroupAccordian
                          key={parameter.TransactionID || parameter.ParameterID}
                          type={"p"}
                          collapse={collapse}
                          expandable={parameters.expandable}
                          title={parameter.ParameterName}
                          ParameterDescription={parameter.ParameterDescription}
                          TransactionID={
                            parameter.TransactionID || parameter.ParameterID
                          }
                          parameterItemNumber={parameter.ItemNumber}
                          dataError={parameters.props.missingParameters?.includes(
                            parameter.ParameterID
                          )}
                          //   caption={"1 KRA * 2 KPIs"}
                          {...parameters.props}
                        >
                          {parameters.expandable && (
                            <parameters.children.Component
                              parameter={parameter}
                              collapse={collapse}
                              {...parameters.children.props}
                            />
                          )}
                        </GroupAccordian>
                      ) : (
                        <></>
                      );
                    })}
                    {parameters.props.permissions.addable && (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-start",
                          margin: "1em 0",
                        }}
                      >
                        <IconButton
                          onClick={() => {
                            parameters.props.addModalHandler(
                              group1.TransactionID
                            );
                          }}
                          sx={{
                            backgroundColor: "#3a82d3",
                            ":hover": { backgroundColor: "#4091ed" },
                          }}
                        >
                          <Add sx={{ color: "white" }} />
                        </IconButton>
                      </Box>
                    )}
                  </GroupAccordian>
                ) : (
                  <></>
                );
              })}
            </Box>
          )}
          {secondGroups.disabled && firstGroups.disabled && (
            <Box>
              {(parameters.list || []).map((parameter) => {
                return (
                  <GroupAccordian
                    key={parameter.TransactionID || parameter.ParameterID}
                    type={"p"}
                    expandable={parameters.expandable}
                    title={parameter.ParameterName}
                    collapse={collapse}
                    TransactionID={
                      parameter.TransactionID || parameter.ParameterID
                    }
                    dataError={parameters.props.missingParameters?.includes(
                      parameter.ParameterID
                    )}
                    parameterItemNumber={parameter.ItemNumber}
                    ParameterDescription={parameter.ParameterDescription}
                    //      caption={"1 KRA * 2 KPIs"}
                    {...parameters.props}
                  >
                    {parameters.expandable && (
                      <parameters.children.Component
                        parameter={parameter}
                        collapse={collapse}
                        {...parameters.children.props}
                      />
                    )}
                  </GroupAccordian>
                );
              })}
            </Box>
          )}
        </Box>
      )}
      {!secondGroups.disabled && secondGroups.props.permissions.addable && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            margin: "1em 0",
          }}
        >
          <IconButton
            onClick={() => secondGroups.props.addModalHandler()}
            sx={{
              backgroundColor: "#3a82d3",
              ":hover": { backgroundColor: "#4091ed" },
            }}
          >
            <Add sx={{ color: "white" }} />
          </IconButton>
        </Box>
      )}
      {secondGroups.disabled &&
        !firstGroups.disabled &&
        firstGroups.props.permissions.addable && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              margin: "1em 0",
            }}
          >
            <IconButton
              onClick={() => firstGroups.props.addModalHandler()}
              sx={{
                backgroundColor: "#3a82d3",
                ":hover": { backgroundColor: "#4091ed" },
              }}
            >
              <Add sx={{ color: "white" }} />
            </IconButton>
          </Box>
        )}
      {secondGroups.disabled &&
        firstGroups.disabled &&
        parameters.props.permissions.addable && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              margin: "1em 0",
            }}
          >
            <IconButton
              onClick={() => parameters.props.addModalHandler()}
              sx={{
                backgroundColor: "#3a82d3",
                ":hover": { backgroundColor: "#4091ed" },
              }}
            >
              <Add sx={{ color: "white" }} />
            </IconButton>
          </Box>
        )}
    </Box>
  );
};

export default ListView;
